export const NEW_RECORDING_ENCRYPTION_SUPPORT_VERSION_RANGE =
  '>=3.13.2 <14.0.0 || >=14.4.0'
